// AddClientPage.js - Full API Integration with Inline Comments

import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

function AddClientPage({ apiRoutes }) {
  const [client, setClient] = useState({
    client_name: "",
    num_people: "",
    phone: "",
    enter_date: "",
    leave_date: "",
    accommodation_address: "",
    accommodation: false,
    who_paid: "",
    transfer_booked: false,
    costs: "",
    additional_costs: "",
    car: "",
    client_description: "",
    result: "",
    agent_name: "",
    request: "",
    what_they_choose: "",
    discounts: "",
    down_payment_date: "",
    property_price: "",
    passportPhoto: null,
    ticketPhoto: null
  });

  const navigate = useNavigate();

  // Handle file selection
  const handleFileChange = (e) => {
    const { name, files } = e.target;
    if (files.length > 0) {
      setClient({ ...client, [name]: files[0] });
    }
  };

  // Handle text/checkbox input changes
  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setClient({ ...client, [name]: type === "checkbox" ? checked : value });
  };

  // Upload a file and return its URL
  const uploadFile = async (file) => {
    const formData = new FormData();
    formData.append("file", file);
    const response = await fetch(apiRoutes.uploadFile, {
      method: "POST",
      body: formData
    });
    const data = await response.json();
    return data.url;
  };

  // Submit form data to the API
  const handleSubmit = async (e) => {
    e.preventDefault();

    let passportPhotoUrl = "";
    let ticketPhotoUrl = "";

    if (client.passportPhoto) {
      passportPhotoUrl = await uploadFile(client.passportPhoto);
    }
    if (client.ticketPhoto) {
      ticketPhotoUrl = await uploadFile(client.ticketPhoto);
    }

    // Prepare the client data object for PHP backend
    const clientData = {
      ...client,
      passport_photo: passportPhotoUrl,
      ticket_photo: ticketPhotoUrl
    };

    // Remove file objects
    delete clientData.passportPhoto;
    delete clientData.ticketPhoto;

    try {
      const response = await fetch(apiRoutes.createClient, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(clientData)
      });
      const result = await response.json();
      if (result.success) {
        alert("Client data saved successfully!");
        navigate("/");
      } else {
        alert("Failed to save client data.");
      }
    } catch (error) {
      console.error("Error saving client data:", error);
      alert("Failed to save client data. Please try again.");
    }
  };

  return (
    <div>
      <h2>Add New Client Tour</h2>
      <form onSubmit={handleSubmit}>
        <h3>Upload Files</h3>
        <label htmlFor="passportPhoto">Passport Photo:</label>
        <input type="file" id="passportPhoto" name="passportPhoto" onChange={handleFileChange} accept="image/*" />

        <label htmlFor="ticketPhoto">Ticket Photo:</label>
        <input type="file" id="ticketPhoto" name="ticketPhoto" onChange={handleFileChange} accept="image/*" />

        <h3>Section 2: Client Tour Info</h3>
        <label htmlFor="client_name">Name of client:</label>
        <input id="client_name" type="text" name="client_name" autoComplete="name" value={client.client_name} onChange={handleChange} required />

        <label htmlFor="num_people">Number of People:</label>
        <input id="num_people" type="number" name="num_people" autoComplete="off" value={client.num_people} onChange={handleChange} />

        <label htmlFor="phone">Client phone number:</label>
        <input id="phone" type="text" name="phone" autoComplete="tel" value={client.phone} onChange={handleChange} />

        <label htmlFor="enter_date">Date and time of entering:</label>
        <input id="enter_date" type="datetime-local" name="enter_date" value={client.enter_date} onChange={handleChange} />

        <label htmlFor="leave_date">Date and time of leaving:</label>
        <input id="leave_date" type="datetime-local" name="leave_date" value={client.leave_date} onChange={handleChange} />

        <label htmlFor="accommodation_address">Accommodation Address:</label>
        <input id="accommodation_address" type="text" name="accommodation_address" autoComplete="street-address" value={client.accommodation_address} onChange={handleChange} />

        <label>
          Accommodation Booked:
          <input type="checkbox" name="accommodation" checked={client.accommodation} onChange={handleChange} />
        </label>

        <label htmlFor="who_paid">Who paid:</label>
        <input id="who_paid" type="text" name="who_paid" value={client.who_paid} onChange={handleChange} />

        <label>
          Transfer Booked:
          <input type="checkbox" name="transfer_booked" checked={client.transfer_booked} onChange={handleChange} />
        </label>

        <label htmlFor="costs">Costs:</label>
        <input id="costs" type="text" name="costs" value={client.costs} onChange={handleChange} />

        <label htmlFor="additional_costs">Additional costs:</label>
        <input id="additional_costs" type="text" name="additional_costs" value={client.additional_costs} onChange={handleChange} />

        <label htmlFor="car">Car:</label>
        <input id="car" type="text" name="car" value={client.car} onChange={handleChange} />

        <label htmlFor="client_description">Client description:</label>
        <textarea id="client_description" name="client_description" value={client.client_description} onChange={handleChange} />

        <label htmlFor="result">Result:</label>
        <textarea id="result" name="result" value={client.result} onChange={handleChange} />

        <h3>Section 3: Agent & Property Info</h3>
        <label htmlFor="agent_name">Agent name:</label>
        <input id="agent_name" type="text" name="agent_name" value={client.agent_name} onChange={handleChange} />

        <label htmlFor="request">Request:</label>
        <textarea id="request" name="request" value={client.request} onChange={handleChange} />

        <label htmlFor="what_they_choose">What They choose:</label>
        <input id="what_they_choose" type="text" name="what_they_choose" value={client.what_they_choose} onChange={handleChange} />

        <label htmlFor="discounts">Our discounts:</label>
        <input id="discounts" type="text" name="discounts" value={client.discounts} onChange={handleChange} />

        <label htmlFor="down_payment_date">Date of Down payment:</label>
        <input id="down_payment_date" type="datetime-local" name="down_payment_date" value={client.down_payment_date} onChange={handleChange} />

        <label htmlFor="property_price">Price of the Property:</label>
        <input id="property_price" type="text" name="property_price" value={client.property_price} onChange={handleChange} />

        <button type="submit">Save Client Tour</button>
      </form>
    </div>
  );
}

export default AddClientPage;
